import FactTable, { type FactTableRow } from "./FactTable";

interface ProductKeyFactsProps {
  title: string;
  rows: readonly FactTableRow[];
}

/**
 * "핵심 정보" — 캠핑 세트·스마트폰·카메라·뷰티 기기의 이 상품만의 사실 2~4줄.
 * 행은 `lib/product-facts/key-facts.ts` 가 DB 값으로만 만든다(없는 값은 행째 빠짐).
 * 오토바이는 같은 행을 "차량 정보" 표에 붙이므로 이 블록을 쓰지 않는다.
 */
export default function ProductKeyFacts({ title, rows }: ProductKeyFactsProps) {
  if (rows.length === 0) return null;
  return (
    <section>
      <h2 className="text-lg sm:text-xl font-semibold mb-4">{title}</h2>
      <FactTable rows={rows} />
    </section>
  );
}
